import React, {
  FC, useEffect,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { useFormikContext } from 'formik'

import style from '@src/pages/Registration/Registration.module.scss'
import { Button } from '@src/components/Button/Button'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
// import { registration } from '@src/store/ducks/auth/thunks'
import { AppDispatch } from '@src/store/store'
// import { CheckBoxFormik } from '@src/components/CheckBoxFormik/CheckBoxFormik'
import { selectBackError, selectIsLoading } from '@src/store/ducks/auth/selectors'
// import { SmsModal } from '@src/components/SmsModal/SmsModal'
import { setBackError } from '@src/store/ducks/auth/reducer'

type RegistrationFormTypes = {
  setFieldValue: any;
}

export const RegistrationForm: FC<RegistrationFormTypes> = () => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)
  const isLoading = useSelector(selectIsLoading)
  // const { values } = useFormikContext<any>()

  useEffect(() => {
    dispatch(setBackError(''))
  }, [dispatch])

  const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'NumpadEnter' || event.code === 'Enter') {
      event.preventDefault()
    }
  }

  return (
    <>
      <div>
        <FieldFormik
          name="password"
          type="password"
          placeholder="Пароль"
          onKeyPressBtn={keyDownHandler}
        />
        <FieldFormik
          name="confirmPassword"
          type="password"
          placeholder="Повторите пароль"
          onKeyPressBtn={keyDownHandler}
        />
      </div>
      {backError && String(backError) && (
        <div className={style.error}>
          *
          {backError}
        </div>
      )}

      <div className={style.btnBlock}>
        {/* <div className={style.note}> */}
        {/*  Нижеперечисленные пункты дают мне право в полном объёме пользоваться скидками, бонусами и другими предложениями в рамках программы */}
        {/*  лояльности ООО «Ресттрэйд»: */}
        {/* </div> */}
        {/* <CheckBoxFormik */}
        {/*  checked={values.isLoyalty} */}
        {/*  name="isLoyalty" */}
        {/*  label={( */}
        {/*    <span> */}
        {/*      {' '} */}
        {/*      Я понимаю и полностью принимаю условия */}
        {/*      <a className={style.link} href="/loyalty" target="_blank"> участия в программе лояльности «Дионис – польза очеВидна!»</a> */}
        {/*    </span> */}
        {/*  )} */}
        {/*  className={style.checkBoxSize} */}
        {/*  onChange={(e) => setFieldValue('isLoyalty', e.target.checked)} */}
        {/* /> */}
        {/* <CheckBoxFormik
          checked={values.isProcessingPersonalData}
          className={style.checkBoxSize}
          name="isProcessingPersonalData"
          label={(
            <span>
              Я согласен с
              <a className={style.link} href="/politika-po-obrabotke-personalnyh-dannyh" target="_blank"> политикой конфиденциальности</a>
              , принимаю все условия и хочу продолжить работу с сайтом.
            </span>
                )}
          onChange={(e) => setFieldValue('isProcessingPersonalData', e.target.checked)}
        /> */}
        {/* <CheckBoxFormik
          checked={values.isPromotionalGames}
          className={style.checkBoxSize}
          name="isPromotionalGames"
          label={(
            <div>Я даю согласие ООО «Ресттрэйд» на участие в рекламных мероприятиях.</div>
                )}
          onChange={(e) => setFieldValue('isPromotionalGames', e.target.checked)}
        /> */}
        <Button
          loading={isLoading}
          htmlType="submit"
          type="secondary"
          // disabled={!values?.isLoyalty}
          className={style.btnSize}
        >
          Активировать карту
        </Button>
      </div>
    </>
  )
}
